import React, { useMemo, useState } from 'react';
import SectionDivider from '../SectionDivider/SectionDivider';
import './TechnicalDetails.scss';
import Section from '../Section/Section';
import { getSpecs, replaceImageURL } from '../helper';
import { useSelector } from 'react-redux';
import { getGundamCollectionName } from '../views/desktop/Gundam/gundamHelper';
import ModalSizeGuide from '../CommonComponents/ModalSizeGuide';

const TechnicalDetails = ({ specifications, thumbnailImage, productId, isAccessories }) => {
  const localeInfo = useSelector(state => state.common.localeInfo);
  const pid = useSelector(state => state.common.productID);
  const dataLocale = useSelector(state => state.locale);
  const { PRODUCT_DETAILS } = dataLocale;
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const specs = useMemo(() => {
    return getSpecs(specifications, dataLocale);
  }, [dataLocale, specifications]);

  return (
    <>
      <div className={`od-pc-technical-details ${isAccessories ? 'hidden' : ''}`}>
        <div className="main-content-wrapper">
          <Section className="od-pc-technical-details__section">
            <SectionDivider
              collapsible
              handleToggleCollapse={() => setIsCollapsed(!isCollapsed)}
              isCollapsed={isCollapsed}
              sectionName={PRODUCT_DETAILS}
            />
            <div
              className={`od-pc-technical-details__collapsible ${
                isCollapsed && 'od-pc-technical-details__collapsible--collapsed'
              }`}
            >
              <div
                className={`od-pc-technical-details__layout ${
                  isCollapsed && 'od-pc-technical-details__layout--collapsed'
                }`}
              >
                <div className="od-pc-technical-details__info">
                  {specs?.length > 0 &&
                    specs?.map(item => (
                      <React.Fragment key={item?.name}>
                        <div className="od-pc-technical-details__item-name od-font-bold">
                          {item?.name}
                        </div>
                        <div className="od-pc-technical-details__item-value od-font-bold">
                          {(() => {
                            switch (item?.name) {
                              case 'Collection':
                                return getGundamCollectionName(productId) ? 'Gundam' : item?.value;

                              case 'Model No.':
                                return `${item?.value} (${productId})`;

                              case 'Frame Dimensions':
                                return (
                                  <>
                                    {item?.value}
                                    <span
                                      className="od-pc-technical-details__item-value-size-guide"
                                      onClick={() => setIsOpen(true)}
                                    >
                                      Size Guide
                                    </span>
                                  </>
                                );

                              default:
                                return item?.value;
                            }
                          })()}
                        </div>
                      </React.Fragment>
                    ))}
                </div>
                <div className="od-pc-technical-details__thumbnail">
                  <img
                    alt={PRODUCT_DETAILS.toLowerCase()}
                    className="od-pc-technical-details__thumbnail__img"
                    src={replaceImageURL(thumbnailImage, localeInfo, pid)}
                  />
                </div>
              </div>
            </div>
          </Section>
        </div>
      </div>
      <ModalSizeGuide isOpen={isOpen} setIsOpen={() => setIsOpen(false)} />
    </>
  );
};

export default TechnicalDetails;
